import React, { useEffect, useState, useMemo, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";
import CustomizedTable from "../CustomizedTable/CustomizedTable";
import UserNameCell from "../CustomizedTable/CustomCells/UserNameCell/UserNameCell";
import UserRoleCell from "../CustomizedTable/CustomCells/UserRoleCell/UserRoleCell";
import PrimaryTextField from "../Inputs/PrimaryTextField/PrimaryTextField";
import { SecurityService } from "../../services/SecurityService";
import { AlertContext, UserRolesContext } from "../Dashboard/Dashboard";

export default function UserManagement({ userUpdated }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [userResults, setUserResults] = useState([]);
  const [search, setSearch] = useState("");
  const userRoles = useContext(UserRolesContext);

  const users = useMemo(() => userResults, [userResults]);

  const columns = useMemo(
    () => [
      {
        Header: "Team Member",
        accessor: "userName",
        filter: "fuzzyText",
        width: 500,
        Cell: UserNameCell,
      },
      {
        Header: "Role",
        id: "role",
        accessor: "role[roleName]",
        filter: "fuzzyText",
        width: 200,
        Cell: UserRoleCell
      }
    ]
  );

  const parseUsers = (res) => {
    res.forEach(r => {
      r.roles = userRoles;
    });
    setUserResults(res);
  };

  const updateUserResults = (rowIndex, columnID, value) => {
    setUserResults(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...row,
            [columnID]: value
          };
        }
        return row;
      })
    );
  };

  useEffect(() => {
    if (userRoles.length) {
      SecurityService.GetUsers(instance).then(res => {
        parseUsers(res);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }

  }, [userRoles, userUpdated]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "end", margin: "0 24px" }}>
        <PrimaryTextField
          placeholder={`Search ${users.length} results`}
          onChange={setSearch}
          value={search}
          isSearch
        />
      </div>
      <CustomizedTable
        id="user-management"
        columns={columns}
        data={users}
        updateData={updateUserResults}
        tableSearch={search}
      />
    </>
  );
}

UserManagement.propTypes = {
  userUpdated: PropTypes.object
};